import {DigitalPageItem} from '../../../interfaces/digital-page-item';
import {ProductTypeEnum} from '../../../interfaces/product-type-enum';

export const DigitalProductPageItem: DigitalPageItem = {
  ProductType: ProductTypeEnum.Sample,
  Title: 'Guten Tag!',
  ProductCode: 'das43',
  Description:
    '<p>Try some of the online revision included with our German revision books. Get full access to all the features when you <a href="[[external_domain]]/info/new-gcse-mfl-books"  class="link-button" style="color: #1494D4"><strong>buy your book</strong></a> and unlock CGP RevisionHub with the unique code printed inside!</p>\n',
    //'\n'+
    //'<p>Want to try another language? Check&nbsp;out the&nbsp;CGP RevisionHub for&nbsp;<a href="/samples/fas44"  class="link-button" style="color: #1494D4"><strong>French</strong></a>&nbsp;and&nbsp;<a href="/samples/spas43"  class="link-button" style="color: #1494D4"><strong>Spanish</strong></a>.</p>\n',
  Credits:
    '<p><em>Contributors: Ben Ffrancon Dowds, Jackie Shaw, Coralie Stewart, Sarah Sweeney </em></p>\n'+
    '\n'+
    '<p><em>Proofreaders: Pat Dunn, Natalie Handley, Natalie Pomier, Véronique Robine</em></p>\n'+
    '\n'+
    '<p><em>AQA material is reproduced by permission of AQA. The worked solutions to questions and commentaries on questions and possible answers in this product have neither been provided by nor approved by AQA.</em></p>\n'+
    '\n'+
    '<p><em>Audio produced by Voice Talent Online.</em></p>\n'+
    '\n'+
    '<p><em>Text, design, layout and original illustrations &copy; Coordination Group Publications Ltd. (CGP) 2024. All rights reserved.</em></p>\n',
  FreeSampleContent:
    '<strong>This is a free sample of the CGP RevisionHub for GCSE German. <u><a href="[[external_domain]]/info/new-gcse-mfl-books" style="color: #FF9335;">Order</a></u> your book now for full access to online German revision.</strong>',
};
